<template>
  <header class="l-header header">
    <nav class="navbar columns is-gapless">
      <div class="navbar-brand column is-narrow logo">
        <router-link @click.native='routerClick' :to="{name: 'Home'}">
          <img :src="$configs.LOGO_MAIN" width="99" :lt="$configs.COMPANY">
        </router-link>
      </div>
      <div v-if="isLogoLandscape"
        class="navbar-brand column is-narrow logo logo--bis is-border-bottom is-border-right">
        <img :src="$configs.LOGO_MAIN_LANDSCAPE" height="80" :lt="$configs.COMPANY">
      </div>
      <div class="navbar-menu is-border-bottom">
        <div class="columns is-gapless full-width">
          <div class="navbar-start columns column is-gapless is-2"
            :class="{'is-3 is-3-widescreen': isLogoLandscape, 'is-2': !isLogoLandscape}"
          >
            <div class="column columns is-centered  is-vcentered is-border-right dropdown is-left tile-notifications has-cursor-pointer"
              style="display: flex; flex-direction: column;"
              :class="{'is-active': displayEvents}"
              @mouseleave="displayEvents = false" @click="displayEvents = !displayEvents">
              <div v-if="newEvents.length > 0" class="badge has-badge-rounded has-badge-medium has-badge-notification" :data-badge="newEvents.length">
                <span class="icon is-size-4"><i class="fal fa-lg fa-bell"></i></span>
              </div>
              <div v-else>
                <span class="icon is-size-4"><i class="fal fa-lg fa-bell"></i></span>
              </div>
              <span class="is-size-6 is-padding-top-xsmall nav-label has-text-primary">
                Notifications
              </span>
              <div v-if="displayEvents && events.length > 0 && $route.name !== 'EventList'" class="dropdown-menu has-cursor-inherit"
                   id="event-dropdown-menu" role="menu">
                <div class="dropdown-content has-text-left">
                  <transition-group enter-active-class=""
                                    leave-active-class="animista exit">
                    <div v-for="event in fiveLastEvents" :key="event.pk">
                      <a v-if='event.link' :href="event.link"  @click='routerClick'
                         class="columns is-padding-top-xsmall is-border-bottom line-notification has-text-primary">
                      <div
                        class="column is-narrow is-padding-left-small is-paddingless-right is-paddingless-top is-padding-bottom-small">
                      <span class="avatar">
                        <span class="has-bg-notification has-text-white">
                          <i class="fal fa-bell"></i>
                        </span>
                      </span>
                      </div>
                      <div
                        class="column is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
                        <a @click.prevent.stop="removeEvent(event)"><i class="fal fa-trash has-text-grey"></i></a>
                        <p class="has-text-grey is-size-7 is-margin-bottom-xsmall">
                          {{ event.created_on | timeDelta}}</p>
                        <p class="is-size-4"><strong>{{event.title}}</strong></p>
                        <p class="is-size-6"><span class="has-text-grey">{{event.description}}</span></p>
                      </div>
                    </a>
                    <a v-else
                         class="columns is-padding-top-xsmall is-border-bottom line-notification has-text-primary">
                      <div
                        class="column is-narrow is-padding-left-small is-paddingless-right is-paddingless-top is-padding-bottom-small">
                      <span class="avatar">
                        <span class="has-bg-notification has-text-white">
                          <i class="fal fa-bell"></i>
                        </span>
                      </span>
                      </div>
                      <div
                        class="column is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
                        <a @click.prevent.stop="removeEvent(event)"><i class="fal fa-trash has-text-grey"></i></a>
                        <p class="has-text-grey is-size-7 is-margin-bottom-xsmall">
                          {{ event.created_on | timeDelta}}</p>
                        <p class="is-size-4"><strong>{{event.title}}</strong></p>
                        <p class="is-size-6"><span class="has-text-grey">{{event.description}}</span></p>
                      </div>
                    </a>
                    </div>
<!-- 
                    <a v-for="event in fiveLastEvents" :key="event.pk" :href="event.link"  @click='routerClick'
                         class="columns is-padding-top-xsmall is-border-bottom line-notification has-text-primary">
                      <div
                        class="column is-narrow is-padding-left-small is-paddingless-right is-paddingless-top is-padding-bottom-small">
                      <span class="avatar">
                        <span class="has-bg-notification has-text-white">
                          <i class="fal fa-bell"></i>
                        </span>
                      </span>
                      </div>
                      <div
                        class="column is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
                        <a @click.prevent.stop="removeEvent(event)"><i class="fal fa-trash has-text-grey"></i></a>
                        <p class="has-text-grey is-size-7 is-margin-bottom-xsmall">
                          {{ event.created_on | timeDelta}}</p>
                        <p class="is-size-4"><strong>{{event.title}}</strong></p>
                        <p class="is-size-6"><span class="has-text-grey">{{event.description}}</span></p>
                      </div>
                    </a> -->
                  </transition-group>
                  <div v-if="events.length > 0"
                       class="column is-padding-top-small is-padding-bottom-small is-size-6 is-border-bottom is-padding-left-large has-cursor-default">
                    <router-link :to="{name: 'EventList'}" class="is-margin-left-small">Voir toutes les notifications
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <router-link @click.native='routerClick' :to="{name: 'OptionList'}" v-if="showOptions" style="display: flex; flex-direction: column;" class="column columns is-centered is-vcentered is-border-right">
              <div v-if="pendingOptions.length > 0" class="badge has-badge-rounded has-badge-medium has-badge-notification" :data-badge="pendingOptions.length">
                <span class="icon is-size-4">
                  <i class="fal fa-lg fa-flag"></i>
                </span>
              </div>
              <div v-else>
                <span class="icon is-size-4">
                  <i class="fal fa-lg fa-flag"></i>
                </span>
              </div>
              <span class="is-size-6 is-padding-top-xsmall nav-label has-text-primary">
               Options
              </span>
            </router-link>
          </div>
          <div class="navbar-content header-searchinput">
            <div
              class="field is-grouped columns column is-vcentered is-paddingless is-padding-right has-bg-light is-border-right"
              :class="{'is-degrad-info': searchValue && searchValue.length}">
              <form @submit.prevent.stop="search(searchValue)" class="is-expanded control">
                <input id="recherche" name="recherche" v-model="searchValue" class="input is-large is-size-3"
                       @input="search" :class="{'has-text-white': searchValue && searchValue.length}"
                       type="text" v-validate="'required|min:2'" placeholder="Saisir un ou plusieurs mots clés">
              </form>
              <p class="control is-padding-right">
                <a v-if="searchValue && searchValue.length > 0" @click.prevent.stop="cancelSearch"
                   class="has-text-white">
                  <i class="fa-lg fal fa-times"></i>
                </a>
                <a v-else @click.prevent.stop="search(searchValue)"><i class="fa-lg fal fa-search"></i></a>
              </p>
            </div>
          </div>
          <div v-if="isLog" class="navbar-end columns column is-narrow is-vcentered dropdown is-right is-relative" @mouseleave="displayMenu = false">
            <a class="dropdown-trigger has-cursor-pointer" @click="displayMenu = !displayMenu">
              <div class="is-radius-large is-padding-right-small">
                  <span class="avatar is-circled is-inline-block is-vcentered">
                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                                mode="out-in">
                      <img key="currentUserPicture" class="veryFastAnimation" v-if="currentUserPicture"
                           :src="currentUserPicture | avatarHeader" width="56" height="56">
                      <img key="default" class="veryFastAnimation" v-else src="/static/default-avatar.jpg" width="40"
                           height="40">
                    </transition>
                  </span>
                <span class="has-text-grey is-inline-block is-padding-left is-padding-right-xsmall"
                      style="min-width:130px;">
                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                                mode="out-in">
                      <b key="currentUserName" class="veryFastAnimation" v-if="currentUserName">{{currentUserName}}</b>
                      <b key="default" class="veryFastAnimation" v-else>Bienvenue</b>
                    </transition>
                  </span>
                <span class="is-size-7"><i class="fal fa-chevron-down has-text-grey is-padding-right"></i></span>
              </div>
            </a>
            <div class="dropdown-menu has-cursor-inherit is-block dropdown-menu-bg-light" v-if="displayMenu">
              <div class="dropdown-content has-text-left is-paddingless-bottom">
                <router-link @click.native='routerClick()' :to="{name: 'UserVue', params: {id: 'me'}}" class="dropdown-item"><span class="icon"><i class="fas fa-user"></i></span><b>Mes infos</b></router-link>
                <a v-if="canDisplayRemuneration || isSuperAdmin" @click="updateRemuneration" class="dropdown-item">
                  <span class="icon" v-if="currency === 'EUR'"><i class="far fa-euro-sign"></i></span><b>{{!displayRemuneration ? 'Afficher' : 'Cacher'}} les rémunérations</b></a>
                <!-- <a class="dropdown-item">Configuration</a> -->
                <router-link v-if="isSuperAdmin" @click.native='routerClick()' :to="{name: 'UserStatsVue'}" class="dropdown-item"><span class="icon"><i class="far fa-chart-bar "></i></span><b>User Stats</b></router-link>
                <a :href="faqPath" v-if="faqEnabled && faqPath && isSuperAdmin" target="_blank" class="dropdown-item"><span class="icon"><i class="fas fa-question-circle"></i></span><b>Guide Utilisateur</b></a>
                <!--<hr v-if="faqEnabled && faqPath" class="navbar-divider">-->
                <a @click.prevent.stop="logout()" id="logout-link" class="dropdown-item"><span class="icon"><i class="fas fa-sign-out"></i></span><b>Déconnexion</b></a>
                <span class="dropdown-item is-size-6 is-border-top has-bg-white is-padding-top-small is-padding-bottom-small">Version {{appVersion}}<span v-if="device !=='desktop'">/{{device}}</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
  import moment from 'moment'
  import { bus, EVENTS } from '../../services/bus'
  import { mapState, mapGetters } from 'vuex'

  export default {
    data () {
      return {
        searchValue: null,
        displayMenu: false,
        displayEvents: false,
        loadingRemuneration: false
      }
    },
    name: 'AppHeader',
    computed: {
      ...mapState(['events', 'runningOptions', 'currentUser', 'device']),
      ...mapGetters([
        'currentUserName', 'currentUserProfil', 'isExternal', 'isLog', 'isSuperAdmin',
        'newEvents', 'currentUserPicture', 'isAdmin', 'pendingOptions', 'orderedEvents',
        'displayRemuneration', 'canDisplayRemuneration'
      ]),
      appVersion () {
        return process.env.npm_package_version
      },
      showOptions () {
        const okProfils = ['admin', 'manager', 'seller', 'manager_ext', 'seller_ext', 'sector_manager']
        return okProfils.includes(this.currentUserProfil)
      },
      fiveLastEvents () {
        return this.orderedEvents.slice(0, 5)
      },
      faqPath () {
        let host = this.$configs.APPHOST
        let token = this.currentUserProfil + ';' + moment().format('DD/MM/YYYY') + ';' + host
        this.routerClick()
        return 'https://faq.vadimm.fr?token=' + btoa(token)
      },
      faqEnabled () {
        return JSON.parse(this.$configs.FAQ_ENABLED)
      },
      isLogoLandscape () {
        return (this.$configs.LOGO_MAIN_LANDSCAPE && this.$configs.LOGO_MAIN_LANDSCAPE !== '')
      },
      currency () {
        return this.$currency
      }
    },
    methods: {
      routerClick () {
        this.$store.commit('setQuickview', {})
      },
      removeEvent (event) {
        this.$api.eventService.delete(event.pk)
      },
      logout () {
        bus.$emit(EVENTS.LOGOUT)
        this.$store.commit('logout')
        this.$store.commit('initState')
        this.$router.push({name: 'Login'})
        localStorage.removeItem('token')
      },
      cancelSearch () {
        this.searchValue = null
        bus.$emit(EVENTS.CLOSE_SEARCH_PANEL)
      },
      search () {
        bus.$emit(EVENTS.INIT_SEARCH_PANEL, this.searchValue)
        this.$store.commit('setQuickview', {})
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      updateRemuneration () {
        if (this.loadingRemuneration) return
        this.loadingRemuneration = true
        this.$api.currentUserService.patch({display_remuneration: !this.displayRemuneration}).then(r => {
          this.loadingRemuneration = false
          this.$store.commit('setCurrentUser', {user: r.data})
        }).catch(() => {
          this.loadingRemuneration = false
        })
      }
    },
    mounted () {
      bus.$on(EVENTS.CLEAN_SEARCH_INPUT, () => {
        this.searchValue = null
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/LayoutHeader.vue